import { render, staticRenderFns } from "./DepthModal.vue?vue&type=template&id=6c5bd5f2&scoped=true&"
import script from "./DepthModal.vue?vue&type=script&lang=js&"
export * from "./DepthModal.vue?vue&type=script&lang=js&"
import style0 from "./DepthModal.vue?vue&type=style&index=0&id=6c5bd5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5bd5f2",
  null
  
)

export default component.exports